import Router from './routes';

const App = () => <Router />;

export default App;
